import styled from 'styled-components'

interface IProps {
    active: boolean
}
export const Button = styled.a<IProps>`
    text-decoration: none;
    color: ${ props => props.active ? '#fff' : '#007aff' };
    background-color: ${ props => props.active ? '#4CAF50' : 'transparent' };
    padding: 10px 15px;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
        color: ${ props => props.active ? '#fff' : '#ff2d55' };
        background-color: ${ props => !props.active && '#eee' };
    }
`
